import { Box } from '@mui/material';
import React from 'react';

export const DpFullContainer: React.FC<{ children: React.ReactNode }> = ({ children }) => (
	<Box sx={{ marginBottom: { xs: 'var(--spacing-8)', sm: 'var(--spacing-13)' } }}>{children}</Box>
);
